import isInLengthValidatorUtil from '../is-in-length'

function passwordValidatorUtil (value) {
  return isInLengthValidatorUtil({
    key: 'password',
    name: 'Password',
    max: 255,
    min: 6,
    value
  })
}

export default passwordValidatorUtil
